<div class="form-group" [formGroup]="formGroup">
  <div class="chkwrap">

    <div>
      <label for="" class="mt-3">{{formField.label}}</label>
    </div>
    <div *ngFor="let option of formField.options | async">
      <label [for]="formField.label">
        <input type="radio" [formControlName]="formField.key" [value]="option.key">
        {{option.value}}
      </label>
    </div>

  </div>
</div>
